import gql from 'graphql-tag';

export const createExpertoBannerPreference = gql`
  mutation createExpertoBannerPreference($userId:ID!, $showBanner:Boolean!) {
    createExpertoBannerPreference(
      input: {
        userId: $userId,
        showBanner: $showBanner
      }) {
      showBanner
      id 
    }
  }
`;
